import styled from 'styled-components'

export const Wrapper = styled.div`
	margin-top: 24px;

	&:first-child {
		margin-top: 16px;
	}
`
